import "./PageAbout.css";
import Bold from "../style/styleBold";
import { useState, useRef, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About BCGAP</title>
        <meta
          name="description"
          content="BCGAP's mission is to provide financial support to college students to promote higher education and to end college debt."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Bent Christy Graduate Assistance Program",
            alternateName: "BCGAP",
            url: "https://bcgap.org/about-bent-christy-graduate-assistance-program",
            foundingDate: "2019",
            description:
              "The Bent Christy Graduate Assistance Program is a nonprofit organization founded in 2019 to provide financial assistance to undergraduates and parents struggling with college loan repayment.",
            mission:
              "To provide financial assistance to undergraduates and parents struggling with college loan repayment and to alleviate the burden of college debt.",
            sameAs: ["https://bcgap.org"],
          })}
        </script>
      </Helmet>
      <div className="about-section">
        <div className="about-block">
          <div className="about-paragraph">
            <div className="content">
              <div className="title">Who We Are</div>
              <div className="about-block-text">
                <p>
                  <Bold>Bent Christy Graduate Assistance Program</Bold> is a nonprofit organization founded in 2019 with a mission to provide financial assistance to undergraduate students and parents managing the burden of college loan repayment.
                  We believe that higher education should be a pathway to opportunity—not a source of long-term financial stress. For many students and families, the pursuit of a degree requires a significant financial commitment, often resulting in debt that can overshadow the value of their achievement and limit future possibilities.
                  Our organization was created in response to this growing challenge. We are committed to helping individuals and families navigate the financial realities of higher education by easing the pressure of student loan repayment and supporting their path toward greater financial stability.
                  Through our work, we aim to ensure that education remains a tool for empowerment. By reducing the burden of college debt, we help create space for graduates and families to focus on building their futures with confidence.

                  {/*
                  <Bold>Bent Christy Graduate Assistance Program</Bold> is a
                  nonprofit organization founded in 2019 with a mission to
                  provide financial assistance to undergraduate students and
                  parents managing student loan repayment. We believe higher
                  education should be a pathway to opportunity—not a source of
                  long-term financial stress. For many students and families,
                  earning a degree comes with a significant financial burden
                  that can impact their long-term stability. Our organization
                  was created to help ease that burden. We support undergraduate
                  students and their parents by reducing the pressure of student
                  loan debt and helping them move toward greater financial
                  stability. Through our work, we aim to ensure education
                  remains a tool for empowerment, allowing graduates and
                  families to focus on building their futures with confidence.
                  */}
                  {/*
                  <Bold> Bent Christy Graduate Assistance Program</Bold> is a
                  non-profit organization founded in 2019 with the mission of
                  providing financial assistance to undergraduates and parents
                  struggling with college loan repayment. In the landscape of
                  higher education, where dreams are forged and futures shaped,
                  the journey often begins with a significant investment –
                  college education. For many, this investment manifests in the
                  form of student loans. However, for some graduates and
                  parents, the burden of these loans can become overwhelming,
                  overshadowing the joy of achievement with the stress of
                  financial strain. Our vision is fueled by her passion for
                  education and a commitment to ending the college debt crisis.
                */}
                </p>

                {/*
                                  Founded in 2019, the{" "}
                  <Bold>Bent Christy Graduate Assistance Program (BCGAP)</Bold>{" "}
                  emerged in response to the growing crisis of college loan debt
                  in our communities. In the landscape of higher education,
                  where dreams are forged and futures shaped, the journey often
                  begins with a significant investment – college education.
                  Unfortunately, for many graduates and their families, these
                  loans can become a heavy burden, overshadowing the joy of
                  achievement with the stress of financial challenges. At BCGAP,
                  we are dedicated to reducing the financial strain that college
                  loans impose on families today. Our vision is fueled by our
                  passion for education and a commitment to ending the college
                  debt crisis.

                */}
              </div>
            </div>
            <div className="image">
              {/*<img src="./images/about/image101.webp" alt="" />
               */}
              <div className="image-wrapper">
                <img
                  style={{
                    objectPosition: "-5rem 0rem",
                  }}
                  src="./images/about/image107.webp"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="about-paragraph">
            <div className="image">
              <div className="image-wrapper">
                <img
                  style={{ objectPosition: "0 0" }}
                  src="./images/about/try9.webp"
                  alt=""
                />
              </div>
            </div>
            <div className="content">
              <div className="title">Our Mission</div>
              <div className="about-block-text">
                <p>
                  Our mission is to provide financial assistance to undergraduates and parents struggling with college loan repayment, helping to reduce financial stress and support long-term stability.
                  {/*
                  Our mission is to provide financial assistance to
                  undergraduate students and their parents to help reduce the
                  burden of student loan repayment and support long-term
                  financial stability.

                  Our mission is to provide financial
                  assistance to undergraduates and parents struggling with
                  college loan repayment. We aim to alleviate the burden of
                  college debt, empowering individuals to pursue their goals
                  with confidence. Together, we strive to make education a
                  source of empowerment, not financial hardship.*/}
                </p>
              </div>
            </div>
          </div>
          <div className="about-paragraph">
            <div className="content">
              <div className="title">Our Vision</div>
              <div className="about-block-text">
                <p>
                  We envision a future where higher education strengthens opportunity without creating lasting financial hardship—where students and families can pursue their goals free from the weight of overwhelming debt.
                  {/*
                 Our vision is a future where higher education leads to
                  opportunity, not long-term financial hardship, and where
                  undergraduate students and their families can build stable
                  financial futures free from overwhelming student loan debt.

                  At <Bold> Bent Christy Graduate Assistance Program</Bold>, we
                  envision a world where a person's access to higher education
                  is determined not by the size of their bank account, but by
                  the boundless capacity of their mind. Our dream is to create a
                  future where financial barriers or the weight of student debt
                  no longer prevent individuals from reaching their full
                  potential.*/}
                </p>
              </div>
            </div>
            <div className="image">
              <div className="image-wrapper">
                <img
                  style={{ objectPosition: "0 41%" }}
                  src="./images/about/image14.webp"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="about-paragraph">
            <div className="image">
              <div className="image-wrapper">
                <img src="./images/about/image11.webp" alt="" />
              </div>
            </div>
            <div className="content">
              <div className="title">Our Values</div>
              <div className="about-block-text">
                <ul>
                  <li>
                    <Bold>Equity</Bold>: We believe in equal access to education
                    for all, striving to remove financial barriers and create
                    opportunities for every student.
                  </li>
                  <li>
                    <Bold>Integrity</Bold>: We operate with transparency and
                    accountability, ensuring that resources are used efficiently
                    and ethically. We uphold the highest standards of integrity
                    and transparency in our operations, ensuring accountability
                    to our stakeholders.
                  </li>
                  <li>
                    <Bold>Impact</Bold>: We measure success by the positive
                    impact on individuals' lives and society as a whole.
                  </li>
                  <li>
                    <Bold>Empathy</Bold>: We understand and empathize with the
                    challenges faced by individuals burdened with student debt,
                    guiding our efforts with compassion and understanding.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
